<template>
  <div>
    <v-navigation-drawer v-model="sidebar" app>
      <v-list nav>
        <v-list-item link to="/clients">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Clients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/proposals">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Proposals</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/domains">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Domains</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/monthlyexpenses">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Monthly Expenses</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="sidebar = !sidebar" />
      <v-toolbar-title>
        <router-link :to="{ name: 'home' }">DCRM</router-link>
      </v-toolbar-title>
      <v-spacer />
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text>
            {{ user.email }}
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title @click="doLogout">Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { auth } from "@/firebase";

export default {
  name: "navbar",
  data: () => ({
    sidebar: true
  }),
  props: {
    user: null
  },
  methods: {
    doLogout() {
      auth.signOut();
    }
  }
};
</script>

<style></style>
